



















































































import { ShowCaseCreditsListVueGB } from "@/extensions/products/ShowCaseCreditsListVueGB";
import BackLink from "@/components/app/BackLink.vue";
import Preloader from "@/components/app/Preloader.vue";
import { Component } from "vue-property-decorator";

@Component({
  components: { BackLink, Preloader }
})
export default class ShowCaseCreditsList extends ShowCaseCreditsListVueGB {

	mounted(): void {
		this.init();
	}

	created() {
    window.addEventListener('resize', this.updateAppropriateImage);
  }

  destroyed() {
    window.removeEventListener('resize', this.updateAppropriateImage);
  }

  updateAppropriateImage(): void {
    this.$forceUpdate();
  }

	appropriateImage(item: any): string {
    return window.innerWidth >= 1441 ? item.Image : item.ImageMp;
  }

}
